import React from 'react';
import { NotificationDropdown } from './NotificationDropdown';

export function TopHeaderBar({ user, sidebarCollapsed }) {
  if (!user) return null;

  const getRoleBadgeStyle = (role) => {
    switch (role) {
      case 'admin':
        return 'bg-emerald-100 text-emerald-800 border-emerald-300';
      case 'farmer':
        return 'bg-green-100 text-green-800 border-green-300';
      case 'processor':
        return 'bg-amber-100 text-amber-800 border-amber-300';
      default:
        return 'bg-blue-100 text-blue-800 border-blue-300';
    }
  };

  const getPortalTitle = (role) => {
    switch (role) {
      case 'admin': return 'Admin Portal';
      case 'farmer': return 'Farmer Portal';
      case 'processor': return 'Processor Portal';
      default: return 'User Portal';
    }
  };

  return (
    <header className="sticky top-0 z-[100] bg-white/90 backdrop-blur-md border-b border-gray-100 px-6 py-2.5 flex items-center justify-between transition-all duration-300">
      {/* Left Portal Title & Breadcrumb */}
      <div className="flex items-center gap-2">
        <span className="text-xs font-bold text-amber-900 uppercase tracking-wider hidden sm:inline">
          {getPortalTitle(user.role)}
        </span>
        <span className="text-gray-300 hidden sm:inline">•</span>
        <span className="text-xs text-gray-500 font-medium truncate max-w-[200px] sm:max-w-none">
          Welcome back, <strong className="text-gray-800">{user.fullname || user.firstName || user.username}</strong>
        </span>
      </div>

      {/* Right Top Bar Actions & Notifications */}
      <div className="flex items-center gap-3">
        <span className={`px-2.5 py-0.5 rounded-full text-xs font-extrabold border capitalize shadow-xs ${getRoleBadgeStyle(user.role)}`}>
          {user.role || 'user'}
        </span>

        {/* Top-Right Notification Bell Component */}
        <div className="bg-amber-900 rounded-xl px-1 py-0.5 shadow-sm">
          <NotificationDropdown user={user} />
        </div>
      </div>
    </header>
  );
}
